import { RegisterPageContent } from "@app/auth/pages";
import { reverseGuardedRoutes } from "@framework/middleware";
import { getGradesService } from "@core/grades/services";
import { getCitiesService } from "@core/shared/services";
import { pageHead } from "@framework/config/drivers";
import { trans } from "@mongez/localization";
import { useLoaderData } from "@remix-run/react";

export const loader = reverseGuardedRoutes(async ({ http }) => {
  const [grades, cities] = await Promise.all([
    getGradesService(http),
    getCitiesService(http),
  ]);

  return {
    grades,
    cities,
  };
});

export default function Register() {
  const { grades, cities } = useLoaderData<typeof loader>();

  return <RegisterPageContent grades={grades} cities={cities} />;
}

export const meta = () => {
  return pageHead({
    title: trans("auth.register"),
  });
};
